import * as vp from 'vopay';
import { Box, Select } from 'vopay';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'UI';

type WorkflowSearchParams = {
  paymentRails: string;
  status: string;
};

type SearchFormProps = {
  paymentRails: string;
  status: string;
  transactionTypesResponse?: vp.TransactionTypesResponse;
  search: (searchParams: WorkflowSearchParams) => void;
};

type FC = FunctionComponent<SearchFormProps>;

const WorkflowSearchForm: FC = (props: SearchFormProps) => {
  const { transactionTypesResponse, paymentRails, status, search } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'TransactionApproval.Configuration.Workflows.SearchForm' });

  const [currentPaymentRails, setCurrentPaymentRails] = useState<string>(paymentRails);
  const [currentStatus, setCurrentStatus] = useState<string>(status);

  const formattedTransactionTypes = (transactionTypesResponse?.TransactionTypes || []).map(({ TransactionType }) => ({
    label: TransactionType,
    value: TransactionType,
  }));

  const paymentRailsOptions = [
    {
      label: t('PaymentRails.Options.all'),
      value: 'all',
    },
    ...formattedTransactionTypes,
  ];

  const statusOptions = [
    { label: t('Status.Options.all'), value: 'all' },
    { label: t('Status.Options.inactive'), value: 'inactive' },
    { label: t('Status.Options.active'), value: 'active' },
  ];

  return (
    <Box flx="row" gap="sm" wrap="wrap" ai="center">
      <Box width="200px">
        <Select
          version="2"
          placeholder={t('PaymentRails.placeholder')}
          options={paymentRailsOptions}
          name="paymentRails"
          value={currentPaymentRails}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentPaymentRails(e.target.value);
          }}
          sort={false}
        />
      </Box>
      <Box width="100px">
        <Select
          version="2"
          placeholder={t('Status.placeholder')}
          options={statusOptions}
          name="status"
          value={currentStatus}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentStatus(e.target.value);
          }}
          sort={false}
        />
      </Box>
      <Button
        id="search-schedule-transactions"
        size="large"
        colorScheme="primary"
        onClick={() => {
          search({
            paymentRails: currentPaymentRails,
            status: currentStatus,
          });
        }}
      >
        {t('submitButton')}
      </Button>
    </Box>
  );
};

export default WorkflowSearchForm;
